import { FC, useEffect, useState } from "react";
import {
    getLabelName, getLogoutRedirectUrl,
     logoutUserFromServer, prepareCloseDayRequest,
     submitCloseDayRequest,
} from "../../utils";
import {
  ActionTypeEnum,
  CloseDayResponseModel,
  PrintTypeEnum,
  RequestActionModel,
  ValidationErrorModel,
} from "../../models";
import {
  ButtonBox,
  ErrorValidationBox,
  GenericModelPopupPdfReportViewer,
  LoadingBox,
  ModelDialogBox,
  TextBox,
} from "..";
import { useFormik } from "formik";
import * as Yup from "yup";
import { logoutUser } from "../../slice/userAuthincateSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {buttonDangerStyle, buttonPrimaryStyle, buttonSizeStyle} from "../transactions/common/css/posCss";

export const CloseDayDetails: FC<{
  onActionEvent: (o: RequestActionModel) => void;
  stationId: number;
  userId: number;
}> = ({ onActionEvent = () => {}, stationId, userId }) => {
  //#region state
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState<
    ValidationErrorModel[]
  >([]);
  const [showPrintoutPdfModel, setShowPrintoutPdfModel] = useState(false);
  // const [showPrintModel, setShowPrintModel] = useState({
  //   show: false,
  //   content: "",
  // });
  const [validationSchema] = useState(
    Yup.object({
      AcctualAmountAfterClose: Yup.number()
        .required(getLabelName("required"))
        .min(0, getLabelName("closeDay.miniValue")),
    })
  );
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      setShowModal(true);
      setLoading(false);
    };
    fillData().then(() => {});
  }, []);
  //#endregion
  //#region formik
  const formik = useFormik({
    initialValues: {
      stationId: 0,
      operationUserId: 0,
      AcctualAmountAfterClose: 0,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values: CloseDayResponseModel) => {
        const request = prepareCloseDayRequest(values);
        await handleSubmit(request);
      // const newValues = {
      //   ...values,
      //   stationId: stationId,
      //   operationUserId: getUserId(),
      // };
      // await handleSubmit(newValues);
    },
  });
  //#endregion
  //#region function
  const handleLogout = async (userId: number) => {
      const result = await logoutUserFromServer(userId);
      if (result.success) {
          dispatch(
              // @ts-ignore
              logoutUser(userId));
          navigate(getLogoutRedirectUrl());
      }
    // const data = await logoutServerUser(userId);
    // if (data?.Errors?.length ?? !data?.Result) {
    // } else {
    //   dispatch(
    //     // @ts-ignore
    //     logoutUser(userId)
    //   );
    //   navigate(SystemConfiguration.others_Configurations.logoutRedirectUrl);
    // }
  };
  const handleClose = () => {
    setShowModal(false);
    onActionEvent({ action: ActionTypeEnum.CloseModelPopup });
  };
  const handleSubmit = async (request: CloseDayResponseModel) => {
      setLoading(true)
      const result = await submitCloseDayRequest(request);
      if (!result.success) {
          setValidationErrors(result.errors || []);
          setLoading(false);
          return;
      }
      setValidationErrors([]);
      if (result.isCurrentUser) {
          // Current user - show print model
          setShowPrintoutPdfModel(true);
      } else {
          // Other user - trigger success action
          setShowModal(false);
          onActionEvent({
              action: ActionTypeEnum.AddSuccess,
              id: request.operationUserId
          });
      }
      setLoading(false);
    // try {
    //   setLoading(true);
    //   const res: any = await saveStationCloseDay(request);
    //   if (
    //     res !== null &&
    //     res !== undefined &&
    //     res.Errors !== null &&
    //     res.Errors !== undefined &&
    //     res.Errors.length !== 0
    //   ) {
    //     setValidationErrors(res.Errors);
    //     setLoading(false);
    //   } else {
    //     setValidationErrors([]);
    //     if (userId == getUserId()) {
    //       //await handleLogout(userId);
    //       secureLocalStorageSet(
    //         SystemConfiguration.miscellaneous_Configurations
    //           .forceLogoutAfterPrint,
    //         "true"
    //       );
    //       setLoading(true);
    //       setShowPrintoutPdfModel(true);
    //       setLoading(false);
    //     } else {
    //       setShowModal(false);
    //       onActionEvent({ action: ActionTypeEnum.AddSuccess, id: userId });
    //       setLoading(false);
    //     }
    //   }
    // } catch (err: any) {
    //   setLoading(false);
    //   const errors: ValidationErrorModel[] = [
    //     { MessageAr: err, MessageEn: err },
    //   ];
    //   setValidationErrors(errors);
    // }
  };
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      <ModelDialogBox
        isModelVisible={showModal}
        isCloseButtonVisible={false}
        isEscapeCloseEnabled={true}
        isXCloseButtonVisible={true}
        onCloseEvent={() => {
          handleClose();
        }}
        size="sm"
      >
        {<ErrorValidationBox errors={validationErrors} />}
        <form className="forms-sample" onSubmit={formik.handleSubmit}>
          <div className="row row-cols-1 row-cols-xxl-1 row-cols-xl-2 row-cols-lg-1 row-cols-md-2 row-cols-sm-2 g-sm-2 g-md-4 align-items-start">
            <TextBox
              labelName={getLabelName("Acctual Money")}
              inputName={"AcctualAmountAfterClose"}
              errorText={formik.errors.AcctualAmountAfterClose}
              inputValue={formik.values.AcctualAmountAfterClose}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              type="number"
            />
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
            <ButtonBox
              type="submit"
              style={{ ...buttonPrimaryStyle, ...buttonSizeStyle }}
              variant="success"
              iconType="content-save"
            >
              {getLabelName("Save")}
            </ButtonBox>
            <ButtonBox
              iconType="receipt"
              variant="danger"
              type="button"
              size="sm"
              style={{ ...buttonDangerStyle, ...buttonSizeStyle }}
              onClick={() => {
                formik.resetForm();
                handleClose();
              }}
            >
              {getLabelName("Cancel")}
            </ButtonBox>
          </div>
        </form>
      </ModelDialogBox>
      {/* Print Modal with PdfViewer */}
      {showPrintoutPdfModel && (
        <GenericModelPopupPdfReportViewer
          keys={[{ key: "stationId", value: stationId }]}
          type={PrintTypeEnum.CloseDay}
          onCloseEvent={async () => {
            setShowPrintoutPdfModel(false);
            await handleLogout(userId);
          }}
        />
      )}

      {/*<ModelDialogBox*/}
      {/*    isModelVisible={showPrintModel.show}*/}
      {/*    isCloseButtonVisible={true}*/}
      {/*    onCloseEvent={async () => {*/}
      {/*      setShowPrintModel({show: false, content: ""});*/}
      {/*      await handleLogout(); // Log out the user after closing the print modal*/}
      {/*    }}*/}
      {/*>*/}
      {/*  <PdfViewer content={showPrintModel.content} />*/}
      {/*</ModelDialogBox>*/}
    </>
  );
  //#endregion
};
